export default __webpack_public_path__ + "static/media/carnevaca.20491eb6.jpg";